<template>
    <div class="nav-buttons-container">
      <!-- 功能标题，只在有按钮时才显示 -->
      <span 
        v-if="buttons && buttons.length > 0" 
        class="function-title mr-5 text-white font-bold text-md whitespace-nowrap">
        <i class="el-icon-s-tools"></i>
        功能
      </span>
      
      <!-- 动态生成按钮 -->
      <el-button 
        v-for="button in buttons"
        :key="button.id"
        :type="button.type || 'primary'" 
        :size="button.size || 'small'"
        class="nav-action-button"
        :icon="button.icon"
        :loading="button.loading"
        @click="handleButtonClick(button)">
        <span class="button-text">{{ button.text }}</span>
      </el-button>
    </div>
  </template>
  
  <script>
  import deviceAPI from '@/api/device'
  
  export default {
    name: 'NavButtons',
    props: {
      buttons: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        refreshLoading: false,
        selectedBridgeId: null
      }
    },
    computed: {
      // 按钮是否显示基于传入的buttons数组
      hasButtons() {
        return this.buttons && this.buttons.length > 0;
      }
    },
    mounted() {
      // 从localStorage获取桥梁ID
      const savedBridge = localStorage.getItem('selectedBridge');
      if (savedBridge) {
        try {
          const bridge = JSON.parse(savedBridge);
          this.selectedBridgeId = bridge.id;
        } catch (error) {
          console.error('解析已保存的桥梁数据出错', error);
        }
      }
      
      // 监听桥梁变更事件
      this.$root.$on('bridge-changed', this.handleBridgeChanged);
    },
    beforeDestroy() {
      // 取消监听
      this.$root.$off('bridge-changed', this.handleBridgeChanged);
    },
    methods: {
      handleBridgeChanged(bridge) {
        if (bridge && bridge.id) {
          this.selectedBridgeId = bridge.id;
        }
      },
      navigateTo(route) {
        this.$router.push(route);
      },
      handleAddDevice() {
        this.$emit('add-device');
      },
      async handleRefreshDevices() {
        if (!this.selectedBridgeId) {
          this.$message.warning('请先选择桥梁');
          return;
        }
        
        this.refreshLoading = true;
        try {
          const response = await deviceAPI.getDevicesByBridge(this.selectedBridgeId);
          if (response.code === 200 && response.data) {
            this.$emit('refresh-devices', response.data);
            this.$message.success('刷新成功');
          } else {
            this.$message.error('获取设备列表失败：' + (response.message || '未知错误'));
          }
        } catch (error) {
          console.error('获取设备列表出错:', error);
          this.$message.error('获取设备列表出错：' + (error.message || '浏览器网络有波动，请稍后再试'));
        } finally {
          this.refreshLoading = false;
        }
      },
      handleButtonClick(button) {
        this.$emit('button-click', button);
      }
    }
  }
  </script>
  
  <style scoped>
  .nav-buttons-container {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .function-title {
    font-size: 14px;
    letter-spacing: 0.5px;
    font-weight: 500;
  }
  
  .nav-action-button {
    background-color: #1976D2;
    border: none;
    border-radius: 4px;
    padding: 6px 14px;
    color: white;
    font-weight: 500;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
    transition: all 0.2s ease;
    height: 30px;
    min-width: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .nav-action-button:hover {
    background-color: #2196F3;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
  }
  
  .button-text {
    margin-left: 6px;
    font-size: 13px;
    white-space: nowrap;
  }
  
  /* 响应式调整 */
  @media (max-width: 768px) {
    .nav-action-button {
      padding: 5px 10px;
      min-width: auto;
    }
    
    .button-text {
      font-size: 12px;
    }
  }
  
  @media (max-width: 576px) {
    .nav-action-button {
      padding: 4px 8px;
    }
    
    .button-text {
      display: none;
    }
    
    .function-title {
      display: none;
    }
  }
  </style>